import React from 'react';
import { useNavigate } from 'react-router-dom'
import { FacebookIcon, InstagramIcon, LanguageIcon, LinkedIn } from '../../assets/icons/IconComponents';
import { useTranslation } from 'react-i18next';
import Popover from '../utils/Popover'

function Footer() {
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()

  const goToLink = (code) => {
    if(code == 'terms') {
      // navigate('/termsAndConditions')
      window.open('https://feentapp.com/termsAndConditions', '_blank')

    } else if(code == 'privacy') {
      // navigate('/privacyPolicy')
      window.open('https://feentapp.com/privacyPolicy', '_blank')

    } else if(code == 'linkedIn') {
      window.open('https://hr.linkedin.com/in/feentappC4%87-9b0a45188', '_blank')
    
    } else if(code == 'facebook') {
      window.open('https://facebook.com/feentapp/', '_blank')
    
    } else if(code == 'instagram') {
      window.open('https://www.instagram.com/feentapp/', '_blank')

    } else if(code == 'eula') {
      window.open('https://feentapp.com/eula', '_blank')

    } else if(code == 'childSafetyPolicy') {
      window.open('https://feentapp.com/childSafetyPolicy', '_blank')

    }
  }

  const setLang = (code) => {
    i18n.changeLanguage(code)
    localStorage.setItem("lng", code)
  }

  return (
    <div className="footer">
      <div className="left-section">
        <Popover trigger={ <span><LanguageIcon /></span> }>
          <div className="dropdown-custom side-drop">
            <div>
              <button onClick={() => setLang('en')}>EN</button>
              <button onClick={() => setLang('hr')}>HR</button>
            </div>
          </div>
        </Popover>
        <span onClick={() => goToLink('terms')}>{t('terms_and_conditions')}</span>
        <span onClick={() => goToLink('privacy')}>{t('privacy_policy')}</span>
        <span onClick={() => goToLink('eula')}>{'EULA'}</span>
        <span onClick={() => goToLink('childSafetyPolicy')}>{t('child_safety_policy')}</span>
      </div>
      <div className="middle-section"></div>
      <div className="right-section">
        <div>
          <span hidden onClick={() => goToLink('linkedIn')}><LinkedIn /></span> 
          <span onClick={() => goToLink('facebook')}><FacebookIcon /></span>
          <span onClick={() => goToLink('instagram')}><InstagramIcon /></span>
        </div>
        <div className="bottom">
            feentapp 2026
        </div>
      </div>
    </div>
  );
}

export default Footer
